import i18n from "../../i18n";
import { BookingType, BookingStatus, ServiceScheduledType, RoutingServiceType } from "../../constants/enums";

const listStatus = () => [
  {
    label: i18n.t("Unassigned"),
    value: "UNASSIGNED"
  },
  {
    label: i18n.t("Rejected"),
    value: "REJECTED"
  }
];

const listStatusReserv = () => [
  {
    label: i18n.t("Assigned"),
    value: BookingStatus.ASSIGNED
  },
  {
    label: i18n.t("Rejected"),
    value: BookingStatus.REJECTED
  },
  {
    label: i18n.t("Started"),
    value: BookingStatus.STARTED
  }
];

const listStatusHistorical = () => [
  {
    label: i18n.t("Completed"),
    value: BookingStatus.FINISHED
  },
  {
    label: i18n.t("Cancelled"),
    value: BookingStatus.DELETED
  }
];

const listType = () => [
  {
    label: i18n.t("OpenServices"),
    value: BookingType.OPEN
  },
  {
    label: i18n.t("ClosedServices"),
    value: BookingType.CLOSED
  }
];

const listPlaces = () => [
  {
    label: "CDMX",
    value: "9"
  },
  {
    label: "San Luis Potosí",
    value: "24"
  },
  {
    label: "Querétaro",
    value: "22"
  },
  {
    label: "Guanajuato",
    value: "11"
  }
];

const listScheduledType = () => [
  {
    label: i18n.t("OnDemand"),
    value: ServiceScheduledType.ON_DEMAND,
  },
  {
    label: i18n.t("Reserved"),
    value: ServiceScheduledType.RESERVED,
  },
];

const listRouteType = () => [
  {
    label: i18n.t("Aforo"),
    value: RoutingServiceType.AFORO
  },
  {
    label: i18n.t("Desaforo"),
    value: RoutingServiceType.DESAFORO
  }
];

export { listStatus, listType, listStatusReserv, listStatusHistorical, listPlaces, listScheduledType, listRouteType };
